export enum FetchType {
  instant = 'instant',
  lazy = 'lazy',
}
